var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"totals-indicator"},[_c('div',{staticClass:"totals-indicator__title"},[_vm._v(" "+_vm._s(this.$t(_vm.title)))]),_c('div',{staticClass:"totals-indicator__data"},[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }